if (!window.EcoScentContactNew) {
  window.EcoScentContactNew = {
    sectionSelector: '.contact-new-section',
    storageKey: 'ecoscent_utm_params',
    trackingKeys: ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'],

    readTrackingParameters: function () {
      const namespace = window.EcoScentContactNew;
      const urlParameters = new URLSearchParams(window.location.search);
      const urlCarriesTracking = namespace.trackingKeys.some(function (key) {
        return urlParameters.has(key);
      });

      try {
        if (urlCarriesTracking) {
          const fromUrl = {};
          namespace.trackingKeys.forEach(function (key) {
            fromUrl[key] = urlParameters.get(key) || '';
          });
          sessionStorage.setItem(namespace.storageKey, JSON.stringify(fromUrl));
          return fromUrl;
        }
        return JSON.parse(sessionStorage.getItem(namespace.storageKey) || '{}');
      } catch (error) {
        return {};
      }
    },

    fillTrackingFields: function (section) {
      const namespace = window.EcoScentContactNew;
      const parameters = namespace.readTrackingParameters();

      namespace.trackingKeys.forEach(function (key) {
        const field = section.querySelector('[data-contact-new-tracking="' + key + '"]');
        if (field) field.value = parameters[key] || '';
      });

      const pageUrlField = section.querySelector('[data-contact-new-tracking="page_url"]');
      if (pageUrlField) pageUrlField.value = window.location.href;
    },

    initSection: function (section) {
      window.EcoScentContactNew.fillTrackingFields(section);
    },

    initAllSections: function (root) {
      const namespace = window.EcoScentContactNew;
      const scope = root || document;
      scope.querySelectorAll(namespace.sectionSelector).forEach(namespace.initSection);
    },

    handleSectionLoad: function (event) {
      window.EcoScentContactNew.initAllSections(event.target);
    },

    listen: function () {
      const namespace = window.EcoScentContactNew;

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          namespace.initAllSections();
        });
      } else {
        namespace.initAllSections();
      }

      document.addEventListener('shopify:section:load', namespace.handleSectionLoad);
    },
  };

  window.EcoScentContactNew.listen();
}
